import React from 'react'
import { Tweet } from 'react-twitter-widgets'

import { SocialFeedType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { TitleSection } from '@organisms/TitleSection'

import { Wrapper } from './SocialFeed.styled'

export const SocialFeed = ({ socialFeedTitle, subtitle, socialFeed }: SocialFeedType): JSX.Element => {
    const hasFacebook = socialFeed.find((item) => item.type === 'facebook')

    const totalFeeds = socialFeed.length

    return (
        <TitleSection title={socialFeedTitle} subtitle={subtitle}>
            <Grid container mdUpSpacing={3}>
                {totalFeeds === 1 && <Grid item xs={12} md={4} />}
                {socialFeed.map((item, i) => {
                    return (
                        <Grid
                            item
                            xs={12}
                            md={4}
                            component={Wrapper}
                            mdUpSpacingLeft={3}
                            mdUpSpacingRight={3}
                            spacingTop={3}
                            spacingBottom={3}
                            key={`${item.type}-${i}`}
                        >
                            {item.type === 'twitter' && (
                                <Tweet tweetId={item.source} options={{ width: '340px', align: 'left' }} />
                            )}
                            {item.type === 'facebook' && (
                                <div
                                    className="fb-post"
                                    data-href={item.source}
                                    data-show-text="true"
                                    data-width="100%"
                                ></div>
                            )}
                            {item.type === 'linkedin' && (
                                <iframe
                                    src={item.source}
                                    width="100%"
                                    height="600px"
                                    frameBorder="0"
                                    title="Embedded post"
                                ></iframe>
                            )}
                        </Grid>
                    )
                })}

                {hasFacebook && (
                    <script
                        async
                        defer
                        crossOrigin="anonymous"
                        src="https://connect.facebook.net/pl_PL/sdk.js#xfbml=1&version=v14.0&appId=1558852850993395&autoLogAppEvents=1"
                        nonce="O3QyjaSb"
                    ></script>
                )}
            </Grid>
        </TitleSection>
    )
}
